import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;
    form: any;
    schema: any;

    asyncValidationLoading: boolean;
    hasAsyncError: boolean;
    asyncErrors: any[];
    remains: any;
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,
    form: null,
    schema: null,

    asyncValidationLoading: false,
    hasAsyncError: false,
    asyncErrors: [],
    remains: null,
};

const initState: any = cloneDeep(state);

export const DEAL_DATA = 'GET_DEAL_DATA';
export const DEAL_SCHEMA = 'GET_DEAL_SCHEMA';
export const SELECT_ROLES_OP = 'SELECT_ROLES_OP';
export const SELECT_GRANTS_OP = 'SELECT_GRANTS_OP';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(DEAL_DATA)
                    .raw('documents.get')
                    .action({
                        id: params.id
                    }),
                // vm.$q(SELECT_ROLES_OP)
                //     .raw('documents.list')
                //     .action({
                //         columns: {
                //             id: 'role.id',
                //             code: 'role.code',
                //             name: 'role.name'
                //         },

                //         from: 's:access_roles',
                //         from_as: 'role',
                //         order: [
                //             {$asc: ['role.name']}
                //         ]
                //     }),
                //   vm.$q(SELECT_GRANTS_OP)
                //     .raw('documents.list')
                //     .action({
                //         columns: {
                //             id: 'grantisimo.id',
                //             role_id: 'grantisimo.role_id',
                //             actor_id: 'grantisimo.actor_id'
                //         },

                //         from: 's:access_role_grants',
                //         from_as: 'grantisimo',
                //         where: {
                //             $eq: [`grantisimo.actor_id`, {$: params.id}]
                //         }
                //     }),
            ]).then((result: ServerResult) => {
                commit('SET_FORM_DATA', {
                    document: result.getOperation(DEAL_DATA).getContent(),
                    // allRoles: result.getOperation(SELECT_ROLES_OP).getContent(),
                    // grants: result.getOperation(SELECT_GRANTS_OP).getContent(),
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    loadRemains({commit, state}, silent) {
        const vm = (this as any)._vm;
        return new Promise((resolve, reject) => {
            if (!silent) commit('START_LOADING');

            vm.$db([
                vm.$q("SELECT_WAREHOUSE")
                    .raw('warehouse')
                    .action({
                        warehouse_id: state.form.delivery_warehouse_id,
                        date: moment(state.form.expected_delivery_date).format('YYYY-MM-DD'),
                    }),
            ]).then(((result: ServerResult) => {
                console.log(result)
                commit('SET_REMAINS_DATA', result.getOperation("SELECT_WAREHOUSE").getContent());
                if (!silent) commit('LOADED_SUCCESS');

                resolve();
            }));
        });
    },

    prepareNew({ commit, rootState }, initParams) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(DEAL_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:deals`
                    })
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    schema: result.getOperation(DEAL_SCHEMA).getContent(),
                    initParams,
                    defs: {
                    //     manager_id: (rootState as any).ubic.actor.document.id
                    }
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    // toggleCredentials({commit}) {
    //     commit('TOGGLE_CREDS');
    // },

    // toggleRoleSelection({commit}, roleID) {
    //     commit('TOGGLE_ROLE', roleID);
    // },

    changeFormValue({state, commit}, {field, newValue}) {
        commit('CHANGE_VALUE', {field, newValue});

        if (['delivery_point_id', 'expected_delivery_date', 'type_id', 'client_id', 'delivery_warehouse_id', 'status_id', 'payment_type_id'].includes(field)) {
            if(
                !state.form.client_id ||
                !state.form.expected_delivery_date ||
                !state.form.delivery_point_id ||
                !state.form.delivery_warehouse_id
            ) {
                return;
            }

            commit('START_ASYNC_VALIDATION');

            const vm = (this as any)._vm;

            const runDuplicateCheck = (specialOrders: boolean) => {
                if (specialOrders) {
                    if (process.env.NODE_ENV === 'development') {
                        console.debug('[deal-dup-check] skip', {
                            clientId: state.form.client_id,
                            specialOrders: true,
                            reason: 'special_orders'
                        });
                    }
                    commit('SET_ASYNC_ERROR', []);
                    commit('SET_AVAILABILITY_DATE');
                    return;
                }

                if (process.env.NODE_ENV === 'development') {
                    console.debug('[deal-dup-check] run', {
                        clientId: state.form.client_id,
                        pointId: state.form.delivery_point_id,
                        date: state.form.expected_delivery_date
                    });
                }

                vm.$db([
                    vm.$q('CHECK_DEAL_EXIST')
                        .raw('documents.list')
                        .action({
                            columns: {
                              id: 'deal.id',
                              expected_delivery_date: 'deal.expected_delivery_date',
                            },

                            from: 's:deals',
                            from_as: 'deal',
                            joins: [
                              {
                                join: 's:statuses',
                                type: 'left',
                                as:   'status',
                                on: { $eq: ['status.id', 'deal.status_id'] }
                              },
                            ],
                            where: {
                              $and: [
                                ...(
                                  state.document.id ? [
                                    {
                                      $not: [
                                        {
                                          $eq: ['deal.id', {$: state.document.id}]
                                        }
                                      ]
                                    },
                                  ] :
                                  []
                                ),
                                { $eq: ['deal.client_id', {$: state.form.client_id}] },
                                { $eq: ['deal.delivery_warehouse_id', {$: state.form.delivery_warehouse_id}] },
                                { $eq: ['deal.delivery_point_id', {$: state.form.delivery_point_id}] },
                                ...(state.form.payment_type_id ? [{ $eq: ['deal.payment_type_id', {$: state.form.payment_type_id}] }] : []),
                                { $and: [
                                    { $eq: ['deal.type_id', {$: state.form.type_id}] },
                                    { $not: [{$eq: ['deal.type_id', {$: 'd:deals_types:4'}] }]},
                                ] },
                                { $eq: ['deal.expected_delivery_date', {$: moment(state.form.expected_delivery_date).format('YYYY-MM-DD')}] },
                                ...(state.form.counterparty_id ? [{ $eq: ['deal.counterparty_id', {$: state.form.counterparty_id}] }] : []),
                                { $not: [{ $eq: ['status.id', {$: 'd:statuses:19' }]}]},
                              ]
                            }
                          }),
                ])
                .then((result: ServerResult) => {
                    const docs = result.getOperation('CHECK_DEAL_EXIST').getContent().documents;

                    if(docs.length && state.form.status_id != 'd:statuses:19') {
                        console.info('[deal-dup-check] blocked', {
                            clientId: state.form.client_id,
                            found: docs.length
                        });
                        commit('SET_ASYNC_ERROR', [
                            'В базе уже имеется заявка по данному клиенту в указанную точку доставки'
                        ]);
                    } else {
                        commit('SET_ASYNC_ERROR', []);
                    }
                    commit('SET_AVAILABILITY_DATE');
                })
            };

            if (typeof state.form.client_special_orders === 'boolean') {
                runDuplicateCheck(state.form.client_special_orders);
                return;
            }

            vm.$db([
                vm.$q('CLIENT_SPECIAL_ORDERS')
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'c.id',
                            special_orders: 'c.special_orders'
                        },
                        from: 's:clients',
                        from_as: 'c',
                        where: {
                            $eq: ['c.id', {$: state.form.client_id}]
                        },
                        page_size: 1
                    })
            ])
            .then((result: ServerResult) => {
                const docs = result.getOperation('CLIENT_SPECIAL_ORDERS').getContent().documents || [];
                const specialOrders = !!(docs[0] && docs[0].special_orders);
                commit('CHANGE_VALUE', { field: 'client_special_orders', newValue: specialOrders });
                runDuplicateCheck(specialOrders);
            })
            .catch((error: any) => {
                console.error('[deal-dup-check] client_special_orders_fetch_failed', error);
                runDuplicateCheck(false);
            });
        }

    },

    // changeCredentialsValue({commit}, {field, newValue}) {
    //     commit('CHANGE_CREDS_VALUE', {field, newValue});
    // },

    saveForm({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        const normalizedForm = state.schema.fields.reduce((prev: any, field: any) => {
            const fieldName = field.code;

            if (state.form[fieldName]) {
                switch(field.type) {
                    case 'date': {
                        prev[fieldName] = moment(state.form[fieldName]).utc().local().format('YYYY-MM-DD');
                        break;
                    }
                    case 'credentials': {
                        prev[fieldName] = {
                            login: state.form[fieldName].login,
                            password: state.form[fieldName].password ? state.form[fieldName].password : ''
                        };
                        break;
                    }
                    default: {
                        prev[fieldName] = state.form[fieldName]
                    }
                }

            }

            return prev
        }, {});

        console.log('normalizedForm', normalizedForm);

        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            // console.log('1')
            let saveQuery = null;
            // console.log('2')
            if (params.id) {
                saveQuery = vm.$q('DEAL_DATA_SAVE')
                    .update(params.id, normalizedForm)
                    // .createManyRelation('access_role_grants', 'actor_id', (createRelated: Function) => {
                    //     return state.form.roles.filter((roleId: any) => !state.grants.map((grant: any) => grant.role_id).includes(roleId))
                    //         .map((item: any, index: number) => createRelated({ role_id: item}));
                    // })
                    // .deleteManyRelation('access_role_grants', 'actor_id', (deleteRelated: Function) => {
                    //     return state.grants.filter((grant: any) => !state.form.roles.includes(grant.role_id))
                    //         .map((item: any, index: number) => deleteRelated(item));
                    // })
            } else {
                saveQuery = vm.$q('DEAL_DATA_SAVE')
                    .create('s:deals', normalizedForm)
                    // .withManyRelation('access_role_grants', 'actor_id', (createRelated: Function) => {
                    //     return state.form.roles.filter((roleId: any) => !state.grants.map((grant: any) => grant.role_id).includes(roleId))
                    //         .map((item: any, index: number) => createRelated({ role_id: item}));
                    // })
            }
            console.log('3')
            console.log('saveQuery', saveQuery)

            vm.$db([
                saveQuery
            ]).then((result: ServerResult) => {
                dispatch('loadRemains')
                const operationResult = result.getOperation('DEAL_DATA_SAVE');
                console.log('4')
                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('ON_FORM_SAVE', { document: operationResult.getContent(), savedGrants: state.form.roles})

                    // create_related
                    //     s:access_role_grants/actor_id
                    //         documents
                    if (params.id) {
                        commit('LOADED_SUCCESS');
                    }
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.log('errror', error)
            });
        })
    },

    getDeliveryDate({state, commit}, {delivery_zone_id}) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');


            const delivery_date = moment().format('YYYY-MM-DD');

            vm.$http.get(`/api/v1/get_delivery_date/${delivery_zone_id}/${delivery_date}`, {}, {}).then((response: any) => {
                commit('LOADED_SUCCESS');
                commit('CHANGE_VALUE', {field: 'expected_delivery_date', newValue: moment(response.result).toDate()});
                resolve();
            })
            .catch((error: any) => {
                console.log('errror', error)
            });
        })
    }
};

export const mutations: MutationTree<WorkPlanBoardState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = initState[key]
        }
    },
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },
    START_ASYNC_VALIDATION: (state) => {
        state.asyncValidationLoading = true;
    },
    SET_ASYNC_ERROR: (state, errors: any[]) => {
        state.asyncValidationLoading = false;
        state.hasAsyncError = errors.length > 0
        state.asyncErrors = errors;
    },

    SET_FORM_DATA(state, {document}) {
        state.document = document.document;
        state.schema = document.schema;

        const formData = cloneDeep(state.document);

        for(const field of state.schema.fields) {
            if(['date', 'datetime'].includes(field.type)) {
                formData[field.code] = formData[field.code] ? moment(formData[field.code]).toDate() : null;
            }
        }

        state.form = formData;
    },

    SET_REMAINS_DATA(state, data) {
        state.remains = data.data
    },

    GENERATE_FORM_DATA(state, {schema, initParams, defs}) {
        state.document = {};
        state.schema = schema.schema;

        const formData = state.schema.fields.reduce((prev: any, field: any) => {
            if (initParams[field.code]) {
                if(['date', 'datetime'].includes(field.type)) {
                    prev[field.code] = moment(initParams[field.code]).toDate();
                } else {
                    prev[field.code] = initParams[field.code];
                }
            } else if (defs[field.code]) {
                if(['date', 'datetime'].includes(field.type)) {
                    prev[field.code] = moment(defs[field.code]).toDate();
                } else {
                    prev[field.code] = defs[field.code];
                }
            }
            else {
                prev[field.code] = null;
            }

            return prev;
        }, {})
        formData.roles = [];
        formData.type_id = 'd:deals_types:1';
        formData.source = 'crm';

        state.form = formData;
    },

    ON_FORM_SAVE(state, {document, savedGrants}) {
        state.document = document.document;
        state.schema = document.schema;

        const formData = cloneDeep(state.document);
        for(const field of state.schema.fields) {
            if(['date', 'datetime'].includes(field.type)) {
                formData[field.code] = formData[field.code] ? moment(formData[field.code]).toDate() : null;
            }
        }

        state.form = formData;
    },

    SET_AVAILABILITY_DATE(state: WorkPlanBoardState) {
        if (['d:client_types:5', 'd:client_types:8', 'd:client_types:9'].includes(state.form.client_type_id)) {
            const expected_delivery_date = state.form.expected_delivery_date
            const delivery_delay = state.form.delivery_delay || 0
            if (expected_delivery_date && !state.form.availability_date) {
                state.form.availability_date = moment(expected_delivery_date).add(delivery_delay, 'days').toDate()
            }
        }
    },

    CHANGE_VALUE(state: WorkPlanBoardState, {field, newValue}) {
        console.log('!! --> ', field, newValue);
        switch (field) {
            default:
                state.form[field] = newValue;
        }
    },
};

const getters = {
    fields: (state: WorkPlanBoardState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_deal_details_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
